module.exports = __webpack_public_path__ + "assets/img/warrior-name-6e98bc9a.png";